<div class="container-area">
  <div id="chart-pie-angle" #chartPieAngle></div>
  <div *ngIf="!DataChartPieAngle.load" class="container-loader-chart">
    <div class="loader loader-1 chart">
      <div class="loader-outter chart"></div>
      <div class="loader-inner chart"></div>
    </div>
  </div>
</div>
